
export class NotEnoughBSVError extends Error
{ // beware before changing this is parsed in translateErrorMessage.js
    constructor(nbsatoshistosend, balancebsv) {
      super(); 
      this.name 				      = "NotEnoughBSVError"; 
      this.nbsatoshistosend 	= nbsatoshistosend
      this.balancebsv 		    = balancebsv
    }

    toString(){
        return this.name+" : nbsatoshistosend="+this.nbsatoshistosend+" balancebsv="+this.balancebsv
    }
}


export class BSVTooSmallSendAmountError extends Error
{ // beware before changing this is parsed in translateErrorMessage.js
    constructor(nbsatoshistosend, bsvfee) {
      super(); 
      this.name 			      	= "BSVTooSmallSendAmount"; 
      this.nbsatoshistosend 	= nbsatoshistosend
      this.bsvfee 			      = bsvfee
      this.sendsatoshis_afterfees = nbsatoshistosend - bsvfee
    }

    toString(){
        return this.name+" : nbsatoshistosend="+this.nbsatoshistosend+" bsvfee="+this.bsvfee
    }
}
